import { brl, esc } from './format';

// Prova social: aviso com ganhadores instantâneos reais. Mesma mecânica do
// toast da home do site (single-page/components/InstantWinnerToast) e a mesma
// chave no localStorage — quem já viu um ganhador lá não vê de novo aqui.
const STORAGE_KEY = 'eds_shown_instant_winners';
const MAX_STORED_IDS = 200;
const FIRST_DELAY_MS = 4000;
const SHOW_MS = 6000;
const EXIT_MS = 350;
const MIN_GAP_MS = 8000;
const MAX_GAP_MS = 15000;
const POLL_MS = 60000;

function loadShownIds() {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
    return Array.isArray(stored) ? stored : [];
  } catch (error) {
    return [];
  }
}

function markShown(id) {
  try {
    const ids = loadShownIds();
    ids.push(id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids.slice(-MAX_STORED_IDS)));
  } catch (error) {
    // storage indisponível (modo privado): o aviso só pode se repetir
  }
}

// Ganhadores ainda não exibidos neste dispositivo nem já enfileirados.
export function freshWinners(winners, shownIds, queuedIds) {
  const shown = new Set(shownIds);
  return (winners || []).filter((winner) => (
    winner.first_name
      && winner.prize_value != null
      && !shown.has(winner.id)
      && !queuedIds.has(winner.id)
  ));
}

export function toastHtml(winner) {
  return `<span class="iw-ic" aria-hidden="true">🎁</span>`
    + `<span><strong>${esc(winner.first_name)}</strong> ganhou `
    + `<b>${brl(winner.prize_value)}</b> em prêmio instantâneo</span>`;
}

export default function startToast(el, url) {
  if (!el || !url || typeof fetch !== 'function') return;

  const queue = [];
  const queuedIds = new Set();
  let busy = false;

  function showNext(delay) {
    if (busy || queue.length === 0) return;
    busy = true;

    setTimeout(() => {
      const winner = queue.shift();
      markShown(winner.id);
      el.innerHTML = toastHtml(winner);
      el.hidden = false;
      requestAnimationFrame(() => el.classList.add('on'));

      setTimeout(() => {
        el.classList.remove('on');
        setTimeout(() => {
          el.hidden = true;
          busy = false;
          showNext(MIN_GAP_MS + Math.random() * (MAX_GAP_MS - MIN_GAP_MS));
        }, EXIT_MS);
      }, SHOW_MS);
    }, delay);
  }

  function load(initial) {
    fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then((response) => (response.ok ? response.json() : []))
      .then((winners) => {
        const fresh = freshWinners(winners, loadShownIds(), queuedIds);
        if (fresh.length === 0) return;

        fresh.forEach((winner) => queuedIds.add(winner.id));
        queue.push(...fresh);
        showNext(initial ? FIRST_DELAY_MS : MIN_GAP_MS);
      })
      .catch(() => {
        // silencioso: prova social nunca pode quebrar a página
      });
  }

  load(true);
  setInterval(() => load(false), POLL_MS);
}
